<template>
  <div>
    <watch-face-list
      :menu-type="activeMenu"
      :input-search-value="inputSearchValue"
      :watch-faces="
        watchfaceList.filter((item) => canUse(item.deviceType ?? ''))
      "
      :categorize="true"
      :compact-uncategorized="false"
      :preview-imgs="previewImgs"
      @update-watchface="updateWatchface"
    />
  </div>
</template>

<script setup lang="ts">
import { PropType, computed, onActivated, watch } from 'vue';
import {
  useEmitterListener,
  useHomePreviewImgs,
  useWatchfaceDevices,
  useWatchfaceHistory
} from '@/hooks';
import WatchFaceList from '../watchface-list/index.vue';
import { EventType } from '@/utils/emitter.utils';
import { debounce } from 'lodash-es';
import { useRoute } from 'vue-router';

const props = defineProps({
  activeMenu: {
    type: String as PropType<'collect' | 'lasted' | 'sample'>,
    default: ''
  },
  inputSearchValue: {
    type: String,
    default: ''
  },
  filterSelected: {
    type: Array<string>,
    default: []
  }
});

const emits = defineEmits<{
  (event: 'update', path: string): void;
}>();

const updateWatchface = (path: string) => {
  emits('update', path);
};

const { historyData, updateItems } = useWatchfaceHistory();
const { canUse } = useWatchfaceDevices();
// const filterSelected = ref<string[]>([]);
const watchfaceList = computed(() =>
  [...historyData.value]
    .filter((item) => props.activeMenu !== 'collect' || item.collect)
    .filter((item) => {
      const search = props.inputSearchValue?.toLocaleLowerCase();
      if (search) {
        const nameMatched = item.title?.toLocaleLowerCase()?.includes(search);
        const deviceTypeMatched = item.deviceType
          ?.toLocaleLowerCase()
          .includes(search);
        return nameMatched || deviceTypeMatched;
      } else {
        return true;
      }
    })
    .filter((item) =>
      props.filterSelected.length
        ? props.filterSelected.includes(item.deviceType ?? '')
        : true
    )
    .sort((a, b) => {
      return (b.lastOpened ?? 0) - (a.lastOpened ?? 0);
    })
);

const route = useRoute();
useEmitterListener(EventType['window:foucs'], () => {
  if (route.name == 'home') {
    updateItems();
  }
});

const { previewImgs, generatePreviews } = useHomePreviewImgs();

const debounceGeneratePreviews = debounce(() => {
  if (route.name != 'home') return;
  generatePreviews(previewPathItems.value);
}, 10);

// 预览图
const previewPathItems = computed(() => {
  return historyData.value.map((item) => {
    return {
      path: item.path,
      deviceType: item.deviceType
    };
  });
});
watch(previewPathItems, debounceGeneratePreviews);
onActivated(debounceGeneratePreviews);

// onBeforeUnmount(() => {
//   try {
//     const _list = [...historyData.value];
//     const paths = _list.map((item) => item.path);
//     if (paths.length) delUsinglessPath(paths);
//   } catch (error) {
//     console.log(error);
//   }
// });
</script>

<style scoped lang="less"></style>
